import styled, { css, keyframes } from 'styled-components';

import { device } from '@/styles/helpers';

const fadeInOut = keyframes`
  0% {
    opacity: 0;
  }
  20% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

interface ScCopyCodeProps {
  copyActive: boolean;
  hoverColor?: string;
  noMarginBottom?: boolean;
}

export const ScCopyCode = styled.div<ScCopyCodeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.03em;
  ${({ noMarginBottom }) =>
    !noMarginBottom &&
    css`
      margin-bottom: 24px;
    `}
  z-index: 2;
  position: relative;
  & > span {
    color: #fff;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 60px;
    line-height: 44px;
    padding: 0 16px;
    position: relative;
    cursor: pointer;
    margin-left: 12px;
    transition: 0.2s;
    display: block;
    @media (hover: hover) {
      &:hover {
        color: rgba(255, 255, 255, 0.6);
      }
    }
    &:before {
      content: attr(data-access);
      position: absolute;
      top: -32px;
      opacity: ${({ copyActive }) => (copyActive ? 1 : 0)};
      transition: opacity 0.2s;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
      text-transform: none;
      text-align: center;
      left: 0;
      right: 0;
      pointer-events: none;

      ${({ copyActive }) =>
        copyActive &&
        css`
          animation: ${fadeInOut} 1s forwards;
        `}
    }
  }
  @media (${device.mobileS}) {
    font-size: 16px;
    ${({ noMarginBottom }) =>
      !noMarginBottom &&
      css`
        margin-bottom: 10px;
      `}
    & > span {
      line-height: 38px;
    }
  }
`;
